export enum ESpecialistTypes {
  Realtors = 'realtors',
  Agencies = 'agentstva',
}
